import React from 'react';
import { X } from 'lucide-react';

const differentiators = [
  'No cookie-cutter plans',
  'No extreme dieting',
  'No disappearing coach',
  'No guesswork'
];

const WhyDifferent = () => {
  return (
    <section className="py-16 sm:py-24 bg-black relative overflow-hidden">
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-10">
            <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3 uppercase tracking-wider">
              Why This Is <span className="text-white/60">Different</span>
            </h2>
            <p className="text-white/50 text-sm sm:text-base leading-relaxed max-w-md mx-auto">
              Most people fail because their plan isn't built for their real life. This coaching is structured, sustainable, and customized.
            </p>
          </div>

          {/* Differentiators */}
          <div className="grid grid-cols-2 gap-3 sm:gap-4">
            {differentiators.map((item, index) => (
              <div 
                key={index}
                className="section-card flex items-center gap-3 py-4"
              >
                <div className="w-8 h-8 bg-white/10 flex items-center justify-center flex-shrink-0">
                  <X className="w-4 h-4 text-white" />
                </div>
                <span className="text-white/80 text-sm font-medium uppercase tracking-wider">{item}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyDifferent;
